import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { EditOutlined, DownOutlined } from '@ant-design/icons';
import { theme, Tooltip, Dropdown, Button } from 'antd';
import DeliveryAddressModal from '../EditDeliveryAddressModal';

const EditDropdownButton = ({
  record,
  link,
  queryParams,
  onEditAddressSuccess,
}) => {
  const { token } = theme.useToken();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleShowAddressModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const menuItems = [
    {
      key: 'envio',
      label: (
        <Link
          to={{
            pathname: `${link}/${record.id ? record.id : record.key}${
              queryParams ? `?${queryParams.toString()}` : ''
            }`,
            state: { record },
          }}
          style={{ color: 'inherit', textDecoration: 'none' }}
        >
          Envío
        </Link>
      ),
    },
    {
      key: 'direccion',
      label: 'Dirección de entrega',
      onClick: handleShowAddressModal,
    },
  ];

  return (
    <>
      <Tooltip title="Editar">
        <Dropdown
          menu={{ items: menuItems }}
          trigger={['click']}
          placement="bottomRight"
        >
          <Button
            type="text"
            size="small"
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '0 4px',
              border: 'none',
              boxShadow: 'none',
            }}
          >
            <EditOutlined style={{ color: token.colorPrimary, fontSize: 18 }} />
            <DownOutlined
              style={{ color: token.colorPrimary, fontSize: 12, marginLeft: 2 }}
            />
          </Button>
        </Dropdown>
      </Tooltip>

      <DeliveryAddressModal
        visible={isModalVisible}
        onClose={handleCloseModal}
        shipment={record}
        onSuccess={onEditAddressSuccess}
      />
    </>
  );
};

EditDropdownButton.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    externalCode: PropTypes.string,
    shippingScheduleDestination: PropTypes.shape({
      name: PropTypes.string,
      shippingAddress: PropTypes.shape({
        addressDetail: PropTypes.string,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        reference: PropTypes.string,
      }),
      phoneNumber: PropTypes.string,
      email: PropTypes.string,
    }),
  }).isRequired,
  link: PropTypes.string.isRequired,
  queryParams: PropTypes.shape(),
  onEditAddressSuccess: PropTypes.func,
};

EditDropdownButton.defaultProps = {
  queryParams: undefined,
  onEditAddressSuccess: () => {},
};

export default EditDropdownButton;
